var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0784 1.95359C9.17224 2.13042 7.3559 2.84635 5.84177 4.01766C4.32765 5.18896 3.17836 6.76719 2.52835 8.56775C1.87834 10.3683 1.75447 12.3167 2.17125 14.1851C2.58802 16.0535 3.5282 17.7645 4.88181 19.1181C6.23542 20.4717 7.94648 21.4119 9.81485 21.8287C11.6832 22.2455 13.6316 22.1216 15.4322 21.4716C17.2328 20.8216 18.811 19.6723 19.9823 18.1582C21.1536 16.644 21.8695 14.8277 22.0464 12.9216C22.1779 11.4482 21.9846 9.96397 21.4799 8.57351C20.9753 7.18304 20.1716 5.92028 19.1256 4.87431C18.0797 3.82835 16.8169 3.02468 15.4264 2.52002C14.036 2.01536 12.5517 1.822 11.0784 1.95359ZM17.4215 9.72719L11.448 15.6384C11.2687 15.8129 11.0285 15.9105 10.7784 15.9105C10.5282 15.9105 10.288 15.8129 10.1088 15.6384L6.58795 12.276C6.404 12.0994 6.29774 11.8569 6.29257 11.6019C6.28739 11.3469 6.38372 11.1003 6.56035 10.9164C6.73698 10.7324 6.97946 10.6262 7.23443 10.621C7.48941 10.6158 7.736 10.7122 7.91995 10.8888L10.7616 13.6152L16.08 8.36159C16.2625 8.19006 16.5048 8.09666 16.7552 8.10132C17.0057 8.10598 17.2444 8.20834 17.4204 8.38654C17.5964 8.56475 17.6958 8.8047 17.6974 9.05517C17.6989 9.30564 17.6025 9.54681 17.4288 9.72719H17.4215Z",
    fill: "#4079F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.b2a5bbcf112b92bcefeb8154333a25ae.svg";
export { ForwardRef as ReactComponent };